import { apiv2Url } from './config';
import { getOption, RequestOptions } from './utils';

export const getStockSearchHistory = (): RequestOptions => {
  return {
    url: `${apiv2Url}/record/search_history?recordType=STOCK`,
    ...getOption(),
  };
};

export const getInfluencerSearchHistory = (): RequestOptions => {
  return {
    url: `${apiv2Url}/record/search_history?recordType=INFLUENCER`,
    ...getOption(),
  };
};

export const getSourceLinkSearchHistory = (): RequestOptions => {
  return {
    url: `${apiv2Url}/record/search_history?recordType=TIPS_SOURCE_LINK`,
    ...getOption(),
  };
};
